import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { AdminUsersPage } from '../pages/AdminUsersPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/admin-users' as any)({
  component: () => (
    <MainLayout>
      <AdminUsersPage />
    </MainLayout>
  ),
  beforeLoad: () => {
    const { isAuthenticated, user } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: '/login' })
    // Client-side gate is convenience only. The API enforces it, so a user
    // who edits their cached flag reaches a 403 rather than any data.
    if (!user?.is_super_admin) throw redirect({ to: '/dashboard' })
  },
})
